import React, { memo, forwardRef, useState, useEffect } from 'react'
import { Form, FormText } from 'react-bootstrap';

const FormSelect = forwardRef((props, ref) => {
  
  const [value, setValue] = useState();

  useEffect(() => {
    if(props.selection)
      setValue(props.selection.id);
  },[props.selection])

  const handleSelectChange = async (e) => {
    setValue(e.target.value);
  }

  return (
    <Form.Group className={props.classes}>
            <Form.Label>{props.label}</Form.Label>
            <Form.Select ref={ref} value={value} onChange={handleSelectChange}>
                {props.list.map((item) => {
                    return(<option value={item.id} key={item.id}>{item.display_name}</option>)
                }).sort()}              
            </Form.Select>
    </Form.Group>
  )
});

export default memo(FormSelect);
